import saunaBnbCakeLp from "../abis/production/saunaBnb/cakeLp";
import steamBnbCakeLp from "../abis/production/steamBnb/cakeLp";
import ssctBnbCakeLp from "../abis/production/ssctBnb/cakeLp";
import busdBoilerCakeLp from "../abis/production/busdBoiler/cakeLp";
import usdtBoilerCakeLp from "../abis/development/usdtBoiler/cakeLp";
import usdcBoilerCakeLp from "../abis/development/usdcBoiler/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "SAUNA-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x555808D7e7b82b9beeF6388b65E1d98cF6069F75",
    abi: saunaBnbCakeLp.abi,
    url: `${host}/0x555808D7e7b82b9beeF6388b65E1d98cF6069F75`,
    decimals: 18,
  },
  {
    name: "STEAM-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x3bcb9d470c8c3bf6a1db0133e172c403d851423c",
    abi: steamBnbCakeLp.abi,
    url: `${host}/0x3bcb9d470c8c3bf6a1db0133e172c403d851423c`,
    decimals: 18,
  },
  {
    name: "SSCT-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x75c2214a0B3067c36D8896f20DD8A350fe029Cb8",
    abi: ssctBnbCakeLp.abi,
    url: `${host}/0x75c2214a0B3067c36D8896f20DD8A350fe029Cb8`,
    decimals: 18,
  },
  {
    name: "BUSD-BOILER Cake LP",
    type: "busd",
    contractAddress: "0xa7a27776f3008d2a6a580e26a1744db900e74580",
    abi: busdBoilerCakeLp.abi,
    url: `${host}/0xa7a27776f3008d2a6a580e26a1744db900e74580`,
    decimals: 18,
  },
  {
    name: "USDT-BOILER Cake LP",
    type: "usdt",
    contractAddress: "0x32673c515b4f913d3fbfd85c09798ef332c7eaaf",
    abi: usdtBoilerCakeLp.abi,
    url: `${host}/0x32673c515b4f913d3fbfd85c09798ef332c7eaaf`,
    decimals: 18,
  },
  {
    name: "USDC-BOILER Cake LP",
    type: "usdc",
    contractAddress: "0xc2a83f6e4a619bfe34b9ffa0ce1078d1a77163d0",
    abi: usdcBoilerCakeLp.abi,
    url: `${host}/0xc2a83f6e4a619bfe34b9ffa0ce1078d1a77163d0`,
    decimals: 18,
  },
];
